import Dialog from './index.vue'
import Vue from 'vue'
import router from '@/router'

let VueComponent = Vue.extend(Dialog)
class DialogCtor {
  constructor (props, pageEl) {
    this.props = props
    this.pageEl = pageEl
  }
  handler () {
    const _this = this

    return new Promise(function (resolve, reject) {
      _this.instance = new VueComponent({
        propsData: _this.props,
        router
      })
      _this.vm = _this.instance.$mount()
      _this.vm.$on('close', () => {
        _this.close(resolve)
      })
      _this.pageEl.appendChild(_this.vm.$el)
    })
  }
  close (resolve) {
    this.vm.$destroy()
    this.pageEl.removeChild(this.vm.$el)
    resolve()
  }
}
export default DialogCtor


